module.exports = __webpack_public_path__ + "img/unnamed4.06ffe50f.png";